import { getDefaultStore } from "jotai";
import { getNestedValue, interpolate, type TranslationKey } from "./hooks/UseTranslation";
import { translationRegistry } from "./Registry";
import { localeAtom } from "./store/atoms";
import type { TranslationNamespace, TranslationParams } from "./store/types";

/**
 * `useTranslation`'s `t` for code outside a component (panel rows, save
 * handlers): reads the locale when called, so the caller's next render
 * picks up a change.
 */
export const translate = <N extends TranslationNamespace>(
  namespace: N,
  key: TranslationKey<N>,
  params?: TranslationParams,
): string => {
  const dictionary = translationRegistry[getDefaultStore().get(localeAtom)][namespace];
  return interpolate(getNestedValue(dictionary, key), params);
};
